export default class ProductSliderFactory {
  constructor() {
    const productSliders = document.querySelectorAll('.products.brick');

    productSliders.forEach((productSlider) => {
      new ProductSlider(productSlider);
    });
  }
}

class ProductSlider {
  constructor(root) {
    const _self = this;
    this.root = root;

    this.slider = this.root.querySelector('.products__items');
    this.slideWidth = 0;
    this.xTouchPos = 0;
    this.index = 0;
    this.maxIndex = 2;

    window.addEventListener('viewport-changed', (e) => {
      _self.initSlider(_self, e.detail.size);
    });
  }

  initSlider(self, size) {
    this.index = 0;
    this.slider.style.transform = 'translateX(0)';

    if (size === 'lg' || size === 'xl') {
      window.removeEventListener('touchstart', this.onTouchStart);
      window.removeEventListener('touchend', this.onTouchEnd);

      return;
    }

    this.onTouchStart = (e) => this.handleTouchStart(this, e);
    this.onTouchEnd = (e) => this.handleTouchEnd(this, e);

    const sliderItem = this.root.querySelector('.products__item'),
      sliderItemStyle =
        sliderItem.currentStyle || window.getComputedStyle(sliderItem);

    if (size === 'sm') {
      this.slideWidth =
        sliderItem.offsetWidth +
        parseFloat(sliderItemStyle.marginLeft) +
        parseFloat(sliderItemStyle.marginRight);
    } else if (size === 'md') {
      this.slideWidth =
        sliderItem.offsetWidth -
        parseFloat(sliderItemStyle.marginLeft) -
        parseFloat(sliderItemStyle.marginRight);
    }

    window.addEventListener('touchstart', this.onTouchStart);
    window.addEventListener('touchend', this.onTouchEnd);
  }

  handleTouchStart(self, e) {
    if (!e.target.closest('.products__items-wrapper')) {
      return;
    }

    self.xTouchPos = e.touches[0].pageX;
  }

  handleTouchEnd(self, e) {
    if (!e.target.closest('.products__items-wrapper')) {
      return;
    }

    const xCurrent = e.changedTouches[0].clientX;
    const xOffset = self.xTouchPos - xCurrent;

    if (xOffset >= 100 && self.index < self.maxIndex) {
      self.index++;
      self.xTouchPos = xCurrent;
    } else if (xOffset <= -100 && self.index > 0) {
      self.index--;
      self.xTouchPos = xCurrent;
    }

    self.slider.style.transform = `translateX(-${self.index * self.slideWidth}px`;
  }
}
